import api from "./api";

// Existing API - Get dashboard data (stats + activities combined)
// Endpoint: GET /dashboard?today_date={date}
export const getDashboardData = async (todayDate: string) => {
  try {
    const response = await api.get(`/dashboard?today_date=${todayDate}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || error.message);
  }
};

// New API - Get recent activities only
// Endpoint: GET /recent_activities?limit={limit}&filter_date={filter_date}
export const getRecentActivities = async (filter_date?: string, limit: number = 20) => {
  try {
    const params: any = { limit };
    if (filter_date) {
      params.filter_date = filter_date;
    }
    const response = await api.get('/recent_activities', { params });
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || error.message);
  }
};